<template>
  <div class="editclass">
    <template v-if="content_json.length > 0">
      <template v-for="(item, index) in content_json">
        <textarea v-if="item.type == 'text'" :key="index" rows="10" placeholder="请输入文字内容" class="form-control" v-model="item.value" @input="filterValue(index)" :data-index="index" @keyup="contentChanged"></textarea>

        <template v-else>
          <div class="progress" :key="index" v-if="item.status == 'uploading'">
            <div class="progress-bar progress-bar-striped progress-bar-animated progress-bar-danger" :style="'width:' + item.progress + '%'" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <template v-else>
            <div class="col-sm-12 news-c-c" :key="index" v-if="item.type == 'image'">
              <img :src="item.value" class="news-c-img" />
            </div>

            <div class="col-sm-12 news-c-c" :key="index" v-else-if="item.type == 'video'">
              <video :src="item.value" class="news-c-img" controls />
            </div>
          </template>
        </template>

        <span :key="index + 's'" class="form-text m-b-none news-c">在这里:
          <span class="label btn btn-warning btn-sm mr-1 ml-1" @click="addText(index)">添加文字</span>
          <span @click="addImg(index)" class="label label-info btn btn-primary btn-sm mr-1">添加图片</span>
          <span @click="addVideo(index)" class="label label-primary btn btn-info btn-sm mr-1">添加视频</span>
          <span @click="deleteItem(index)" class="label label-danger btn btn-danger btn-sm mr-1">删除上面的内容</span>
          <el-progress v-if="item.progress!=0" type="circle" :percentage="item.progress" :width="40"></el-progress>
        </span>
      </template>
    </template>
    <template v-else>
      <span class="label btn btn-warning btn-sm mr-1 ml-1" @click="addText(-1)">添加文字</span>
      <span @click="addImg(-1)" class="label label-info btn btn-primary btn-sm mr-1">添加图片</span>
      <span @click="addVideo(-1)" class="label label-primary btn btn-info btn-sm mr-1">添加视频</span>
    </template>
    <ElChunkUploader ref="uploader2"></ElChunkUploader>
  </div>
</template>

<script>
import ElChunkUploader from "./FileUploader";
import appsettings from "../utils/appsettings";
import Vue from "vue";
export default {
  name: "el-geditor",
  props: ["content", "cat_oid"],
  data: function () {
    return {
      appsettings: appsettings,
      inited: false,
      content_json: [],
      select_index: 0,
    };
  },
  mounted: function () { },
  created: function () { },
  components: {
    ElChunkUploader
  },
  watch: {
    cat_oid: {
      deep: true,
      immediate: true,
      handler (val) {
        // if (this.inited == false) {
        if (!this.content) {
          this.content_json = []
        }

      }
    },
    content: {
      deep: true,
      immediate: true,
      handler (val) {
        // if (this.inited == false) {
        if ((val || "") != "" && val.indexOf("]") > 0) {
          this.content_json = JSON.parse(val);
        } else {
          this.content_json = []
        }
        // this.inited = true;
        // }
      }
    }
  },
  methods: {
    filterValue (index) {
      var str = this.content_json[index].value;
      if (this.content_json[index].value) {
        this.$emit("changed", JSON.stringify(this.content_json));
      }
      //this.content_json[index].value = str.replace(/\s+/g, "")  //.replace(/[\r\n]/g, "")
    },
    addContent () {
      this.content_json = [
        {
          type: "text",
          value: val || ""
        }
      ];
    },
    contentChanged: function (e) {
      var index = e.target.dataset.index;
      if (this.content_json[index].value) {
        this.$emit("changed", JSON.stringify(this.content_json));
      }

    },
    isImg: function (type) {
      type = (type || "").toUpperCase();
      if (
        type == "JPG" ||
        type == "JPEG" ||
        type == "BMP" ||
        type == "PNG"
      ) {
        return true;
      }
      return false;
    },
    isVideo: function (type) {
      type = (type || "").toUpperCase();
      if (type == "MP4") {
        return true;
      }
      return false;
    },

    deleteItem: function (index) {
      this.content_json.splice(index, 1);
      this.$emit("changed", JSON.stringify(this.content_json));
    },
    getBtnText: function (item) {
      if (item.type == "text") {
        return "段文字";
      } else if (item.type == "image") {
        return "张图片";
      } else if (item.type == "video") {
        return "个视频";
      }
    },
    //附件上传成功的回调函数
    uploadSuccess2: function (e, f) {
      var item = this.content_json[this.select_index + f.index + 1];
      item.status = "ok";
      item.value = appsettings.up_prefix + e;
      if (!item) return;
      Vue.set(this.content_json, this.select_index + f.index + 1, item);
      this.$emit("changed", JSON.stringify(this.content_json));
    },
    //附件上传进度变化的回调函数
    uploadProgressChanged2: function (file, files) {
      //上传进度发生变化
      var item = this.content_json[this.select_index + file.index + 1];
      item.progress = file.progress;
      Vue.set(this.content_json, this.select_index + file.index + 1, item);
    },
    // 文件被添加进队列的回调函数
    uploadFileQueued: function (file, files) {
      this.content_json.splice(this.select_index + 1 + file.index, 0, {
        type: this.isImg(file.file_type) == false ? 'video' : 'image',
        value: "",
        status: "uploading"
      });
    },
    //上传新的附件
    uploadAttachment2: function () {
      this.$refs.uploader2.uploadNewFiles(
        {
          url: "utility/upload",
          multiple: true
        },
        this.uploadProgressChanged2,
        this.uploadSuccess2,
        this.uploadFileQueued
      );
    },
    addText: function (index) {
      this.content_json.splice(index + 1, 0, {
        type: "text",
        value: ""
      });
    },
    addImg: function (index) {
      //上传图片
      this.$refs.uploader2.clear();
      this.select_index = index;
      this.uploadAttachment2();
    },
    addVideo: function (index) {
      //上传视频
      this.$refs.uploader2.clear();
      this.select_index = index;
      this.uploadAttachment2();
    }
  }
};
</script>
<style>
.editclass  .form-control{
  width:60%;
}

textarea.form-control{
  height: 150px;
}
.news-c span {
  cursor: pointer;
  font-weight: normal !important;
}

.news-c {
  width: 60%;
  margin-bottom: 10px !important;
  padding: 10px 20px !important;
  border: 1px solid #eee;
}

.news-c-c {
  width:60%;
  text-align: center !important;
  display: flex;
  align-items: flex-end;
  border: 1px solid #eee;
}

.news-c-img {
  width: 200px !important;
}

.label-danger {
  margin-left: 20px;
  font-weight: normal !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/el-GEditor.vue